import { atom } from 'jotai';

/**
 * Whether the "Get Heidi on mobile" modal is open.
 *
 * THE ONE INSTANCE. `SideNavFooter` opens it and the modal reads it, so a
 * second `atom(false)` behind a copied declaration would be two atoms and a
 * footer click that opens nothing. The old app path is a re-export of this.
 */
export const isGetMobileAppModalOpenAtom = atom(false);
